import { pb } from './pocketbase';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

export const getPartners = async ({ page = 1, perPage = 10, filter = null } = {}) => {
  try {
    const options = {
      page,
      perPage,
      sort: '-created'
    };

    if (filter) {
      options.filter = filter;
    }

    const result = await pb.collection('partners').getList(page, perPage, options);
    
    return {
      items: result.items,
      totalPages: result.totalPages,
      totalItems: result.totalItems,
      page: result.page,
      perPage: result.perPage
    };
  } catch (error) {
    console.error('Erreur lors de la récupération des partenaires:', error);
    throw error;
  }
};

export const getPartnerById = async (id) => {
  try {
    const partner = await pb.collection('partners').getOne(id, {
      expand: 'user_id'
    });
    return partner;
  } catch (error) {
    console.error('Erreur lors de la récupération du partenaire:', error);
    throw error;
  }
};

export const createPartner = async (partnerData) => {
    try {
        // Appeler l'API du serveur pour créer un étudiant
        const response = await fetch(`${API_BASE_URL}/api/createPartner`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`
            },
            body: JSON.stringify(partnerData)
        });

        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.error || 'Une erreur inattendue est survenue lors de la création.');
        }

        return responseData;
    } catch (error) {
        console.error('Erreur lors de la création du partenaire:', error);
        if (error.message.includes('Failed to fetch')) {
            throw new Error('Erreur de connexion au serveur. Veuillez réessayer.');
        }
        throw error;
    }
};

export const updatePartner = async (id, partnerData) => {
  try {
    const partner = await pb.collection('partners').update(id, partnerData);
    return partner;
  } catch (error) {
    console.error('Erreur lors de la mise à jour du partenaire:', error);
    throw error;
  }
};

export const deletePartner = async (id) => {
  try {
    await pb.collection('partners').delete(id);
    return true;
  } catch (error) {
    console.error('Erreur lors de la suppression du partenaire:', error);
    throw error;
  }
};

export const deletePartners = async (ids) => {
  try {
    const promises = ids.map(id => pb.collection('partners').delete(id));
    await Promise.all(promises);
    return true;
  } catch (error) {
    console.error('Erreur lors de la suppression des partenaires:', error);
    throw error;
  }
};

export const getPartnerForCurrentUser = async () => {
  try {
      // Vérifier si l'utilisateur est connecté
      if (!pb.authStore.isValid || !pb.authStore.model) {
          throw new Error('Utilisateur non connecté');
      }
      
      const authData = pb.authStore.model;
      
      // Vérifier si l'utilisateur a un student_id
      if (!authData.partner_id) {
          throw new Error('Aucun étudiant associé à cet utilisateur');
      }
      
      // Récupérer directement l'étudiant par son ID
      const partner = await pb.collection('partners').getOne(authData.partner_id);
      
      return partner;
  } catch (error) {
      console.error('Erreur lors de la récupération de l\'étudiant:', error);
      throw error;
  }
};

export const updatePartnerForCurrentUser = async (partnerData) => {
  try {
    if (!pb.authStore.isValid) {
      throw new Error('Utilisateur non connecté');
    }

    const partnerId = pb.authStore.model.partner_id;
    if (!partnerId) {
      throw new Error('Aucun partenaire associé à cet utilisateur');
    }

    const updatedPartner = await pb.collection('partners').update(partnerId, partnerData);
    return updatedPartner;
  } catch (error) {
    console.error('Erreur lors de la mise à jour du partenaire:', error);
    throw error;
  }
};

export const getCurrentPartnerInfo = async () => {
  
  if (!pb.authStore.isValid) return null;

  const user = pb.authStore.model;
  let partner = null;
  
  try {
    if (user.partner_id) {
      partner = await pb.collection('partners').getOne(user.partner_id);
    }
    return partner;
  } catch (error) {
    throw error;
  }
};
